// extracted by css-extract-rspack-plugin
export default {"queryEditor":"TqwY6","editorWrapper":"AGTcs","resizableArea":"w1rS9","resizableBoxContent":"WZxiJ","actionButtons":"e3NAz","readOnlyEditor":"RJz4l"};